import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { proDriverRecordQuery } from "@/app/ProDrivers/Drivers/GraphQL/proDriverRecordQuery";

export function useProDriver(proDriverId: string) {
  const { data } = useSuspenseGqlQuery(proDriverRecordQuery, {
    id: proDriverId,
  });

  return data.proDriver!;
}
